import styled from "styled-components";

export const ProgressTitle = styled.span`
  color: ${(props) =>
    props.progress < 100 ? "#B1B3B3" : props.tema.primaryColor};
  font-size: 14px;
  transition: 0.3s;
`;

export const Progress = styled.span`
  color: ${(props) =>
    props.progress < 100 ? "#B1B3B3" : props.tema.primaryColor};
  font-size: 18px;
  font-weight: 900;
  transition: 0.3s;
`;
